import styled from 'styled-components';

// Modal Container
export const Container = styled.div`
	position: fixed;
	width: 100%;
	height: 100dvh;

	@supports (-webkit-touch-callout: none) {
		height: -webkit-fill-available;
	}

	left: 0;
	right: 0;
	bottom: 0;
	overflow: hidden;
	z-index: 100;

	&::before {
		content: '';
		display: block;
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		width: 100%;
		height: 100dvh;
		@supports (-webkit-touch-callout: none) {
			height: -webkit-fill-available;
		}
		opacity: 30%;
		background-color: ${({ theme }) => theme['black-primary']};
	}
`;

export const Modal = styled.div<{ isButton: boolean }>`
	overflow: hidden;
	width: 100%;
	max-height: 80dvh;
	padding-bottom: ${({ isButton }) => (isButton ? '82px' : '0px')};

	position: fixed;
	left: 0;
	bottom: 0;
	z-index: 100;

	background-color: ${({ theme }) => theme['white-primary']};
	border-top-right-radius: 30px;
	border-top-left-radius: 30px;
	box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
`;

export const ModalCloseHeader = styled.div`
	width: 100%;
	padding: 15px 10px;

	display: flex;
	justify-content: center;
	align-items: center;
`;

export const ModalCloseHeaderBar = styled.div`
	width: 55px;
	height: 5px;
	border-radius: 3px;
	background-color: ${({ theme }) => theme['warmgray-300']};
`;

// Modal Header
export const Header = styled.div`
	width: 100%;
	padding: 10px 20px;

	display: flex;
	justify-content: flex-start;
	align-items: center;

	border-bottom: 1px solid ${({ theme }) => theme['gray-tertiary']};
`;

export const ButtonContainer = styled.div`
	position: fixed;
	bottom: 0;

	width: 100%;
	padding: 15px 24px;

	display: flex;
	justify-content: center;
	align-items: center;
`;
